import React, { Component } from 'react';
import logo from '../images/kalingarayanrunners_logo.svg';
import banner from '../images/banner image.png';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

class GalleryHeader extends Component {
  // Constructor to initialize state
  constructor(props) {
    super(props);
    this.state={
      eventID : props.eventID,
      eventDetails : {}
    }
    }

    componentDidMount() {
      let eventURI = process.env.REACT_APP_API_URL +"/Events/GetEvent";
      fetch(eventURI , {
        method: "POST",
        headers: {
        "Content-Type": "application/json"},
        body: JSON.stringify(this.state.eventID),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          let eventDetails = !!data.Events ? data.Events[0] : null;
          this.setState({eventDetails: eventDetails})
          // setLoading(false);
        })
        .catch(error => {
          // setError(error.message);
          // setLoading(false);
        });
    }

  // Render method to display the component
  render() {
    let eventDate = !!this.state.eventDetails.EventDate ? format(new Date(this.state.eventDetails.EventDate), 'dd_MMM_yyyy') : '';
    return (
      <div  className="relative bg-cover bg-center pb-[60vh]"
      style={{ backgroundImage: `url(${'https://images.unsplash.com/photo-1731902062588-4dce45ccc0cb?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'})` }}>
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        <header className="relative p-4  w-[94%] ml-[3vw]">
            <div className="container mx-auto flex justify-between items-center">
                <div className="text-2xl font-semibold">
                    <Link to="/"> <img 
                        src= {logo} 
                        alt="Logo" 
                        className="sm:max-w-[14rem] max-w-[12rem]  transform scale-140" 
                    /></Link>
                </div>
                <nav>
                  <ul className="flex">
                    <li><Link to="/registration" className="text-sm text-white"><button className='bg-red-600 w-28 h-10 rounded-lg'>Register</button></Link></li>
                    {/* <li><Link to="/register" className="text-sm text-white"><button className='bg-emerald-600 w-28 h-10 rounded-r-lg'>Donate Now</button></Link></li>  */}
                  </ul>
                </nav>
            </div>
        </header>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white bg-opacity-0 bg-white py-6 px-5 rounded">
            <h1 className='text-5xl font-bold'>{this.state.eventDetails.EventName}</h1>
            <p className='pt-4'>{this.state.eventDetails.EventDescription}</p>
            <button className='mt-4 font-bold py-3 px-5 bg-red-700'>Date: {eventDate} / {this.state.eventDetails.EventLocation}</button>
        </div>
      </div>
    );
  }
}

export default GalleryHeader;
